import CategoryPage from '../components/CategoryPage';

export default function Mentorships() {
  return <CategoryPage type="mentorship" title="Instructorales" />;
}
